import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, Injector, inject, provideAppInitializer } from '@angular/core'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { AppInjector } from './core/app-injector'
import { DialogModule } from './shared/dialog/dialog.module'
import { TranslateModule } from '@ngx-translate/core'
import { LangSelectorModule } from './shared/lang-selector/lang-selector.module'
import { UserService } from './core/user/services/user.service'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,

    CoreModule,
    // ServiceWorkerModule.register('/ngsw-worker.js', {
    //   enabled: environment.production
    // }),
    MatSnackBarModule,
    MatProgressSpinnerModule,
    DialogModule,
    TranslateModule,
    LangSelectorModule
  ],
  providers: [
    // Initializers
    provideAppInitializer(() => {
        const initializerFn = (init)(inject(UserService));
        return initializerFn();
      })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    // Store module's injector in the AppInjector class
    AppInjector.setInjector(injector)
  }
}

export function init(userService: UserService) {
  return async () => {
    try {
      // Init User
      await userService.getUser().toPromise()
    } catch (error) {
      console.error(error)
    }
  }
}
